<template>
<el-dialog :visible.sync="dialogVisible" width="500px" title="接收任务">
    <el-form ref="form" :model="acceptInfo" label-width="100px">
        <el-form-item label="回复内容">
            <el-input v-model="acceptInfo.ReplyContent"></el-input>
        </el-form-item>
        <el-form-item label="选择科室">
            <el-select v-model="acceptInfo.DeptId" style="width: 100%;" clearable placeholder="请选择">
                <el-option v-for="item in createDeptOptions" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
            </el-select>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="acceptTaskHandle">确 定</el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    getToken
} from "../../../util/auth";
import {
    acceptTask
} from "@/api/modules/basicData/task";
import {
    GetPubDeptByUserId
} from "@/api/modules/basicData/user";
const cookieUser = getToken();
export default {
    props: {
        taskId: {
            type: String,
            default: ''
        },
        serverCenterIds: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dialogVisible: false,
            acceptInfo: {
                ReplyContent: '',
                DeptId: ''
            },
            createDeptOptions: [],
        }
    },
    mounted() {
        GetPubDeptByUserId(cookieUser.userId).then(result => {
            if (result) {
                this.createDeptOptions = result;
                this.acceptInfo.DeptId = cookieUser.departmentId;
            }
        });
    },
    methods: {
        acceptTaskHandle() {
            this.acceptInfo.TaskId = this.taskId;
            this.acceptInfo.ServerId = this.serverCenterIds;
            this.acceptInfo.UserName = cookieUser.realName;
            this.acceptInfo.UserId = cookieUser.userId;
            //科室
            if (this.acceptInfo.DeptId) {
                let curDeptInfo = this.createDeptOptions.find(item => item.ID == this.acceptInfo.DeptId);
                this.acceptInfo.DeptName = curDeptInfo.NAME;
            } else {
                this.acceptInfo.DeptName = "";
            }
            acceptTask(this.acceptInfo).then(resultMsg => {
                if (resultMsg.ResultCode) {
                    this.$message.success('接收成功');
                    this.dialogVisible = false;
                    this.$emit('successed');
                } else {
                    this.$message.error(resultMsg.MsgInfo);
                }
            });
        },
    }
}
</script>

<style scoped>
.el-dialog__header {
    text-align: left;
}
</style>
